import omit from 'lodash/omit';

import { CANDIDATE_SOURCES } from './NewCandidate.constants';

export const transformCandidateDrafts = drafts => {
  const transformedDrafts = drafts.map(draft => {
    if (draft.dataSheet?.id) {
      return {
        ...omit(draft, 'dataSheet'),
        formData: { ...draft.formData, dataSheet: draft.dataSheet }
      };
    }
    return draft;
  });

  return transformedDrafts;
};

export const getExternalIdAndSource = ({ applicantId = null, resumeId = null }) => {
  if (applicantId) {
    return { source: CANDIDATE_SOURCES.talentPool, externalId: applicantId };
  }
  if (resumeId) {
    return { source: CANDIDATE_SOURCES.resumeParser, externalId: resumeId };
  }

  return { source: null, externalId: null };
};
